import { memo, useCallback } from "react";
import PwmNavigator from "./PwmNavigator";
import classNames from "classnames";
import { MncVars, NavigatorButtomMenu, Routes } from "const";
import RetailNavigator from "./RetailNavigator";
import Portal from "components/Portal";
import { useHistory, useLocation } from "react-router-dom";
import { useMeasureForCssVar } from "components/hooks";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { ModalSelector } from "redux/selector/modals-selector";

const use = [["height", MncVars.Navbar]];

function NavigationBar({ className, forceHideAllMenu, menuSet, ...props }) {
  const history = useHistory();
  const location = useLocation();
  const [navbarRef] = useMeasureForCssVar({ use });
  const isSystemClosePopupActive = useSelector(ModalSelector.isSystemClosePopupActive);

  const renderMenus = () => {
    let MenuNavigatorComponent = null;
    switch (menuSet) {
      case NavigatorButtomMenu.PWM:
        MenuNavigatorComponent = PwmNavigator;
        break;
      case NavigatorButtomMenu.Retail_And_Ultrahigh:
        MenuNavigatorComponent = RetailNavigator;
        break;
      default:
        MenuNavigatorComponent = null;
        break;
    }

    return <MenuNavigatorComponent navigate={navigate} shouldReplaceThisPath={shouldReplaceThisPath} />;
  };

  const wildcardRoutePath = useCallback((pathname) => {
    // replace /:param with /\w+
    return pathname.replace(/\/:\w+/, "/\\w+");
  }, []);

  const shouldReplaceThisPath = useCallback(() => {
    const replacePath = [
      new RegExp(`^${wildcardRoutePath(Routes.Primary.ProductDetail)}`, "i"),
      new RegExp(`^${wildcardRoutePath(Routes.Primary.ComplexProductDetail)}`, "i"),
      new RegExp(`^${wildcardRoutePath(Routes.Secondary.ProductDetail)}`, "i"),
      new RegExp(`^${wildcardRoutePath(Routes.UltraHigh.BuySellSwitching.Buy)}`, "i"),
      new RegExp(`^${wildcardRoutePath(Routes.UltraHigh.BuySellSwitching.Sell)}`, "i"),
      new RegExp(`^${wildcardRoutePath(Routes.UltraHigh.BuySellSwitching.Switch)}`, "i"),
    ];
    return replacePath.some((pathRegex) => pathRegex.test(location.pathname));
  }, [location.pathname, wildcardRoutePath]);

  const navigate = useCallback(
    (path) => {
      const redirectMethod = shouldReplaceThisPath() ? history.replace : history.push;
      redirectMethod(path);
    },
    [history.push, history.replace, shouldReplaceThisPath]
  );

  if (!menuSet || forceHideAllMenu) return null;
  return (
    <Portal id="navigation-bar">
      <NavbarStyled
        ref={navbarRef}
        className={classNames("navigationbar-mnc shadow-secondary", className)}
        $isSystemClosePopupActive={isSystemClosePopupActive}
        {...props}
      >
        {renderMenus()}
      </NavbarStyled>
    </Portal>
  );
}

export default memo(NavigationBar);

const NavbarStyled = styled.div`
  z-index: ${(props) => (props.$isSystemClosePopupActive ? 10020 : 999)};
`;
